import Category from '@/models/Category'
// import API from '@/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    setCategoryList(state, categories) {
      each(categories, category => {
        const exist = find(state.list, { id: category.id })
        if (!exist) {
          state.list.push(new Category(category))
        }
      })
    },

    clearCategoryList(state) {
      state.list = []
    }
  },
  actions: {
    /* Fake fetching as backend doesn't have the necessary APIs yet */
    async getCategories({ commit }, params) {
      // const { data } = await API.get(`jobs/catagories`)
      // commit('setCategoryList', data.data)
      let data = await new Promise((resolve, reject) => {
        resolve([
          { id: 1, label: 'Category 1' },
          { id: 2, label: 'Category 2' },
          { id: 3, label: 'Category 3' },
          { id: 4, label: 'Category 4' },
          { id: 5, label: 'Category 5' }
        ])
      })
      commit('setCategoryList', data)
    }
  }
}
